exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2G9M6{height:100%;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._2G9M6,._3Sjkb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3Sjkb{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1bKaV{height:20px;width:20px;color:#6d6d6d;font-size:16px;cursor:pointer}._3Y7Y8{font-size:15px;font-weight:700;line-height:18px}._3Y7Y8:first-letter{text-transform:uppercase}._3USW_{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:13px;line-height:18px;margin:5px}._3USW_,._31s51{display:-webkit-box;display:-ms-flexbox;display:flex}._3fSjw{display:inline;padding-right:10px;text-transform:lowercase;color:grey}", ""]);

// exports
exports.locals = {
	"root": "_2G9M6",
	"titleBlock": "_3Sjkb",
	"trashIcon": "_1bKaV",
	"savedTitle": "_3Y7Y8",
	"infoBlock": "_3USW_",
	"infoItem": "_31s51",
	"infoTitle": "_3fSjw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SavedSearchItem/SavedSearchItem.css
// module id = 1662
// module chunks = 0 1 15 17 20 22 33 44